import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["trigger",  "typeField"]

  connect() {
    this.toggleStatus()
    this.toggleCheckbox()
  }

  toggleStatus() {
    this.triggerTargets.forEach((trigger) => {
      if (trigger.tagName.toLowerCase() !== "select") return

      const value = trigger.value

      // classroom visible on: enrolled OR waitlist
      const showClassroom = (value === "enrolled" || value === "waitlist")

      const classroomSection = document.querySelector(".student-classroom-selection")
      if (classroomSection) {
        classroomSection.classList.toggle("d-none", !showClassroom)
      }

      // type visible only on: enrolled
      const showType = (value === "enrolled")
      if (this.hasTypeFieldTarget) {
        this.typeFieldTarget.classList.toggle("d-none", !showType)
      }
    })
  }

  // Toggles the visibility of associated fields based on the state of checkboxes in the form
  toggleCheckbox() {
    this.triggerTargets.forEach((trigger, index) => {
      if (trigger.type !== "checkbox") return

      const field = this.element.querySelectorAll("[data-students-form-target='field']")[index]; // Find the corresponding field by index
      if (!field) return

      field.classList.toggle("d-none", !trigger.checked)
    })
  }
}
